<div class="dropdownContent" [class._modeFilter]="modeFilter" [class._modePriority]="modePriority" [class._fullBtnMode]="fullBtnMode">
    <a-button-icon [visibility]="buttonVisibility" [size]="'SMALL'" [disabled]="disabled" (click)="toggleActions()" *ngIf="!fullBtnMode">
        <i class="fa fa-ellipsis-v" *ngIf="!modeFilter && !modePriority && !modeCreation"></i>
        <i class="fa fa-filter" *ngIf="modeFilter"></i>
        <i class="fab fa-get-pocket" *ngIf="modePriority"></i>
        <i class="fas fa-plus" *ngIf="modeCreation"></i>
    </a-button-icon>
    <a-button-default [visibility]="buttonVisibility"
                      [size]="'SMALL'"
                      [disabled]="disabled"
                      (click)="toggleActions()"
                      *ngIf="fullBtnMode">
        {{labelBtnMode}}<i class="fa fa-chevron-down"></i>
    </a-button-default>
    <div [class]="'dropdown' + ' ' + fromPositionDropdown(positionDropdown)" [hidden]="!actionsOpened || disabled" ng-style="{'z-index': 99000}">
        <ng-content></ng-content>
    </div>
</div>
